import React from 'react';
import styles from './busType.module.css';
import Slider from './slider';

/* 파일명이 그대로라 옛 사진이 캐시에 남는다 → ?v 로 새 URL 을 만든다 */
const busImages = [
  {url: '/image/limousine/interior1.jpg?v=2'},
  {url: '/image/limousine/interior2.jpg?v=2'},
  {url: '/image/limousine/interior3.jpg?v=2'},
  {url: '/image/limousine/interior4.jpg?v=2'},
];

const Limousine = () => {
  return (
      <section className={styles.container}>
        <h1 className={styles.title}>28인승 대형 리무진</h1>

        <section className={styles.container}>
          <p className={styles.busDetail}>
            최고급의 편의 시설과 안락한 시트, 각종 고급형 시설을 갖춘 리무진으로서 <br/>
            24인승 ~ 28인승의 단체 여행에 이용됩니다. 고급 골프모임, 동호회, 관공서, 기업체, <br/>
            일반인 모두 이용할 수 있으며 최고급형 대형 버스입니다.
          </p>

          <img
            className={styles.exteriorPhoto}
            src='/image/limousineExterior.jpg?v=3'
            alt='28인승 대형 리무진 외관'
          />

          <h2 className={styles.imageTitle}>차량 사진</h2>

          <Slider imageList={busImages}/>
        </section>
      </section>
  )
};

export default Limousine;